/** The signed-in person, for every component under the gate (`App.tsx`). */
import { createContext, useContext } from "react";

import type { Me } from "./session";

export const MeContext = createContext<Me | null>(null);

export function useMe(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error("useMe outside the signed-in app");
  return me;
}
